<template>
  <section v-if="category">
    <div class="section-head text-6xl">
      {{ category.name }}
    </div>
    <masonry
      :cols="{ default: 3, 768: 1 }"
      :gutter="{ default: '15px' }"
      class="px-4"
    >
      <template v-for="product in products">
        <UiProduct
          class="home__products-product"
          :key="product.id"
          :product="product"
        />
      </template>
    </masonry>
  </section>
</template>

<script>
import { specificCategory } from '@/services/api/category.js'

export default {
  data() {
    return {
      category: null,
      products: []
    }
  },
  mounted() {
    specificCategory(this.$route.params.id).then(response => {
      console.log(response)
      this.category = response.category
      this.products = response.category.products
    })
  }
}
</script>

<style lang="sass"></style>
